"use client"
import GCTextElement from "@/app/(site)/_components/GCMolecules/GCTextElement"
import InformationButton from "@/app/(site)/_components/Page/Product/ProductDetail/InformationButton"
import useEcommerceStore from "@/app/(site)/contexts/ecommerce/store"
import { type LowestPrice } from "@/types/centra/checkout-api/payment/payment-reciept"
import React from "react"

interface PriceProps {
    showAsOnSale: boolean
    productPrice: string
    priceBeforeDiscount: string
    lowestPrice: LowestPrice[]
    langCode: string
}

const Price: React.FC<PriceProps> = ({
    showAsOnSale,
    productPrice,
    priceBeforeDiscount,
    lowestPrice,
    langCode
}) => {
    const { togglePriceHistoryModal } = useEcommerceStore()

    return showAsOnSale ? (
        <div
            className="group flex h-24 cursor-pointer items-center gap-8"
            onClick={togglePriceHistoryModal}
        >
            <GCTextElement
                text={priceBeforeDiscount}
                as="p"
                className="text-col-text-secondary line-through Trim_Mono_POC_Text_14_130_-5_400_uppercase lg:Trim_Mono_POC_Text_15_130_-5_400_uppercase"
            />
            <GCTextElement
                text={productPrice}
                as="p"
                className="text-col-text-primary Trim_Mono_POC_Text_14_130_-5_400_uppercase lg:Trim_Mono_POC_Text_15_130_-5_400_uppercase"
            />

            <InformationButton
                onClick={e => {
                    e.stopPropagation()
                    togglePriceHistoryModal()
                }}
                ariaLabel="Price History"
                className="group-hover:text-col-text-primary"
            />
        </div>
    ) : (
        <GCTextElement
            text={productPrice}
            as="p"
            className="flex h-24 items-center text-col-text-primary Trim_Mono_POC_Text_14_130_-5_400_uppercase lg:Trim_Mono_POC_Text_15_130_-5_400_uppercase"
        />
    )
}

export default Price
